/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const REGIONS_AWS = [
  "af-south-1",
  "ap-east-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-northeast-3",
  "ap-south-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-southeast-3",
  "ca-central-1",
  "cn-north-1",
  "cn-northwest-1",
  "eu-central-1",
  "eu-north-1",
  "eu-south-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "me-south-1",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-gov-east-1",
  "us-gov-west-1",
  "us-west-1",
  "us-west-2",
];

export const REGIONS_AZURE = [
  "eastasia",
  "southeastasia",
  "centralus",
  "eastus",
  "eastus2",
  "westus",
  "northcentralus",
  "southcentralus",
  "northeurope",
  "westeurope",
  "japanwest",
  "japaneast",
  "brazilsouth",
  "australiaeast",
  "australiasoutheast",
  "southindia",
  "centralindia",
  "westindia",
  "canadacentral",
  "canadaeast",
  "uksouth",
  "ukwest",
  "westcentralus",
  "westus2",
  "koreacentral",
  "koreasouth",
  "francecentral",
  "francesouth",
  "australiacentral",
  "australiacentral2",
  "southafricanorth",
  "southafricawest",
];

export const REGIONS_GCP = [
  "asia-east1",
  "asia-east2",
  "asia-northeast1",
  "asia-northeast2",
  "asia-northeast3",
  "asia-south1",
  "asia-southeast1",
  "asia-southeast2",
  "australia-southeast1",
  "europe-north1",
  "europe-west1",
  "europe-west2",
  "europe-west3",
  "europe-west4",
  "europe-west6",
  "northamerica-northeast1",
  "southamerica-east1",
  "us-central1",
  "us-east1",
  "us-east4",
  "us-west1",
  "us-west2",
  "us-west3",
  "us-west4",
];

const REGIONS_IBMCLOUD = [
  "us-south",
  "br-sao",
  "ca-tor",
  "us-east",
  "eu-de",
  "eu-gb",
  "jp-osa",
  "au-syd",
  "jp-tok",
  "kr-seo",
  "in-che",
];

export enum PROVIDER {
  AWS = "AWS",
  AZURE = "AZURE",
  GCP = "GCP",
  IBMCLOUD = "IBMCLOUD",
}

type Regions = {
  [PROVIDER.AWS]: typeof REGIONS_AWS;
  [PROVIDER.GCP]: typeof REGIONS_GCP;
  [PROVIDER.AZURE]: typeof REGIONS_AZURE;
  [PROVIDER.IBMCLOUD]: typeof REGIONS_IBMCLOUD;
};

type Keys = PROVIDER;
type Values = Regions[keyof Regions];

const regions = new Map<Keys, Values>();

regions.set(PROVIDER.AWS, REGIONS_AWS);
regions.set(PROVIDER.GCP, REGIONS_GCP);
regions.set(PROVIDER.AZURE, REGIONS_AZURE);
regions.set(PROVIDER.IBMCLOUD, REGIONS_IBMCLOUD);

const commonRegions = ["global"];
const allRegions = [REGIONS_AWS, REGIONS_GCP, REGIONS_AZURE, REGIONS_IBMCLOUD];

export { regions, commonRegions, allRegions };
